import React from 'react'
import { ReactComponent as SuccessIcon } from '../../../assets/icons/check-circle.svg'
import LeavePage from '../../../assets/icons/leave-page.svg'
import CriticalAction from '../../../assets/icons/danger-circle.svg'
import moment from 'moment'

export const TODAY = moment()

export const ERROR_MESSAGES = {
  requiredField: 'Este campo é obrigatório',
  invalidDate: 'Digite uma data válida'
}

export const MODAL_WARNINGS = {
  LEAVE_APPOINTMENT: {
    title: 'Tem certeza que deseja sair sem salvar?',
    subtitle: 'Ao sair da página sem salvar, você perderá todas as informações sobre essa consulta.',
    confirmButton: 'Sair da página',
    cancelButton: 'Continuar editando',
    icon: LeavePage
  },
  DELETE_APPOINTMENT: {
    title: 'Tem certeza que deseja descartar a ficha dessa consulta?',
    subtitle: 'Ao descartar, você perderá todas as informações sobre essa consulta e não será possível recuperá-las.',
    confirmButton: 'Sim, descartar ficha',
    cancelButton: 'Agora não',
    icon: CriticalAction
  }
}

export const URLS = {
  tutorsAndPets: '/vets/tutores-e-pets/',
  appointment: '/vets/prontuario',
  petDetail: '/vets/detalhes-do-pet',
  home: '/vets'
}

export const INITIAL_DATE = moment().toDate()

export const APPOINTMENT_STATUS = {
  true: 'isEditing',
  false: 'isCreating'
}

export const ANAMNESIS_FIELD_NAMES = ['mainComplaint', 'physicalExam', 'diagnosis', 'treatment', 'observation', 'returnObservation']

export const getAnamnesisFormFields = (appointment) => [
  {
    name: 'mainComplaint',
    label: 'Queixa principal',
    placeholder: 'Descreva os principais motivos que levaram o tutor a procurar atendimento veterinário',
    value: appointment?.mainComplaint || ''
  },
  {
    name: 'physicalExam',
    label: 'Exame físico',
    placeholder: 'Descreva os aspectos gerais do pet, incluindo sinais vitais, condição corporal, palpações e outras observações',
    value: appointment?.physicalExam || ''
  },
  {
    name: 'diagnosis',
    label: 'Diagnóstico',
    placeholder: 'Descreva o diagnóstico identificado para este pet e os achados clínicos',
    value: appointment?.mainComplaint || ''
  },
  {
    name: 'treatment',
    label: 'Tratamento',
    placeholder: 'Descreva o plano de tratamento recomendado, incluindo medicamentos, terapias ou outros procedimentos',
    value: appointment?.diagnosis || ''
  },
  {
    name: 'observation',
    label: 'Observações da consulta',
    placeholder: 'Descreva outras observações importantes relacionadas a este pet',
    value: appointment?.observation || ''
  },
  {
    name: 'returnObservation',
    label: 'Observações sobre o retorno',
    title: 'Informações sobre o dia do retorno',
    placeholder: 'Descreva observações relacionadas ao retorno desse pet, complicações, mudanças, entre outros',
    value: appointment?.returnObservation || ''
  }
]

export const Success = <SuccessIcon />
